"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDocumentTag = isDocumentTag;
exports.isSenderTag = isSenderTag;
exports.mapCayaTagToNatifTag = mapCayaTagToNatifTag;
exports.mapNatifTagToCayaTag = mapNatifTagToCayaTag;
const constants_1 = require("./constants");
function isDocumentTag(string) {
    return Object.values(constants_1.NATIF_DOCUMENT_TAG_MAP).includes(string);
}
function isSenderTag(string) {
    return Object.values(constants_1.NATIF_SENDER_TAG_MAP).includes(string);
}
function mapTagToDictionary(tag, tagDictionary) {
    const lowercasedTag = tag.toLowerCase();
    const mappedTag = tagDictionary[lowercasedTag];
    if (mappedTag) {
        return mappedTag;
    }
    return lowercasedTag;
}
function mapCayaTagToNatifTag(tag) {
    return mapTagToDictionary(tag, constants_1.CAYA_TAG_MAP);
}
function mapNatifTagToCayaTag(tag) {
    return mapTagToDictionary(tag, constants_1.NATIF_TAG_MAP);
}
//# sourceMappingURL=tags.js.map